module.exports = __webpack_public_path__ + "static/media/logo-blue.f015083d.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/brand/logo-blue.png
// module id = 1271
// module chunks = 146